module.exports = __webpack_public_path__ + "img/arrow-up-z-a.e3539d8d.svg";